import { Input as InputAntD, Typography } from 'antd';
import { twMerge } from 'tailwind-merge';
import { Tooltip } from '../Tooltip';
import { StyledError, StyledInputWrapper } from './styles';
import { InputProps } from './types';
import { ETooltipIntents, ETypographyIntents } from '@src/typings';
import { inputVariants } from '@src/utilities/inputVariants';
import { FormLabel } from '../FormLabel';

export const Input = ({
    intent,
    size,
    className,
    children,
    label,
    name,
    error,
    isRequired,
    help,
    ...props
}: InputProps) => {
    return (
        <StyledInputWrapper>
            {(label || help) && (
                <div className="flex w-full items-center justify-between">
                    <FormLabel label={label} required={isRequired} />
                    {help && (
                        <Tooltip
                            title={help}
                            color="secondary"
                            intent={ETooltipIntents.Question}
                        />
                    )}
                </div>
            )}
            <InputAntD
                status={error ? 'error' : props.status}
                variant={intent}
                size={size}
                className={twMerge(
                    inputVariants({
                        className,
                        intent,
                        error: Boolean(error),
                    })
                )}
                {...props}
            />
            {error && (
                <Typography className="text-error mt-1 text-M-12">
                    {error}
                </Typography>
            )}
        </StyledInputWrapper>
    );
};
